import { CommonUtilities } from '../../../commonUtils';

export default class ReleaseService {

    //Project Summary - Scope - Release
    static async ReleaseListing(data: any) {
        var url = 'catalogue/projectAsset/listMyAsset?' + data;
        return CommonUtilities.getData(url);
    }

    //contract Summary - Scope - Release
    static async AssociatedRelease(data: any) {
        console.log(data)
        var url = 'contracts/compilation/associatedReleases/' + data.contractRefNum + "?pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize;
        console.log(url)
        return CommonUtilities.getData(url);
    }

    //Project Summary - Scope - Release- save release details when edit
    static SaveRelease(data: any) {
        var url = 'publishing/TempSongProject/save';
        return CommonUtilities.postData(url, data);
    }

    //Main Genre list
    static GetMainGenreList() {
        var url = 'contracts/genre/main/list';
        console.log(url)
        return CommonUtilities.getData(url);
    }

    static async GetLabelList() {
        var url = 'metadata/label?companyName=&orderBy=CompanyName&sortBy=ASC'
        return CommonUtilities.getData(url);
    }

    static GetSubGenreList(data: any) {

        var url = 'contracts/genre/sub/' + data.id
        console.log(data);
        return CommonUtilities.getData(url);
    }

    static MasterListing(Data: {}) {
        var url = 'metadata/master/search?' + Data;
        console.log(Data)
        return CommonUtilities.getData(url);
    }


    static async listMyassetContractsRelease(data: any) {
        console.log(data);
        var url = "catalogue/projectAsset/listMyassetContracts?" + CommonUtilities.buildQueryString(data, true, true);;
        return CommonUtilities.getData(url);
    }

    static SaveMaster(data: any) {
        var url = 'metadata/master?IsReleaseCount=true';
        return CommonUtilities.postData(url, data);
    }


    static CreateMaster() {
        var url = 'metadata/master/generateItem?labelName=0&IsReleaseCount=true';
        return CommonUtilities.getData(url);
    }

    static GenerateBarcode(data: any) {
        var url = 'contracts/mechanical/release/generateItem?masterCode=' + data.masterRelease + "&codingStr=" + data.formatDesc;
        return CommonUtilities.getData(url);
    }

    static validateReleaseMetaData() {
        var url = 'contracts/metadata/validateReleaseMetaData';
        return CommonUtilities.getData(url);
    }

    static mainContractsSave(data: any) {
        var url = 'contracts/' + data?.contractRefNum + '/mainContracts';
        return CommonUtilities.postData(url, data);
    }

    static getMainContracts(data: any) {
        var url = 'contracts/' + data?.contractRefNum + '/getMainContracts';
        return CommonUtilities.getData(url);
    }

    static genericListing(data: any) {
        var url = 'common/genericListing';
        return CommonUtilities.postData(url, data);
    }

    static zeroFixContractAsset(data: any) {
        var url = 'contacts/zeroFixContractAsset?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static ContractReportingSave(data: any) {
        var url = 'ContractReporting/save';
        return CommonUtilities.postData(url, data);
    }

}